import { render, staticRenderFns } from "./ImsEcnsList.vue?vue&type=template&id=4f6542bb&"
import script from "./ImsEcnsList.vue?vue&type=script&lang=js&"
export * from "./ImsEcnsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports